import type { ReactNode } from "react";
import { Stack } from "@volca/ui/components/ui/stack";
import { cn } from "@volca/ui/lib/utils";
import { useImpersonation } from "@/core/impersonation";

export const ImpersonationFrame = ({ children }: { children: ReactNode }) => {
  const { isImpersonating } = useImpersonation();
  return (
    <Stack
      data-impersonating={isImpersonating || undefined}
      gap={0}
      className={cn("h-svh overflow-hidden bg-surface-sunken", {
        "border-4 border-warning-subtle": isImpersonating,
      })}
    >
      {children}
    </Stack>
  );
};
